import type { ReactNode } from 'react'
import { useContext } from 'react'

import Container from '~/components/atoms/Container/Container'

import { ReportTheme, ThemeAccentContext } from '../types'

import pageStyles from '~/styles/pages.module.css'

export interface ThemeContainerProps {
  children: ReactNode
  theme: ReportTheme
  useContainer?: boolean
  id?: string
}

export default function ThemeContainer({
  children,
  theme,
  useContainer = false,
  id,
}: ThemeContainerProps) {
  const { themeAccent, themeAccentText } = useContext(ThemeAccentContext)

  const renderItem = () => {
    return useContainer ? (
      <Container className="useTheme">{children}</Container>
    ) : (
      children
    )
  }

  const styleProps: { [key: string]: string } = {}

  if (theme === ReportTheme.tertiary) {
    styleProps['--bg'] = themeAccent ? `rgb(${themeAccent})` : 'rgb(10, 10, 10)'
    styleProps['--color'] = themeAccentText
      ? `rgb(${themeAccentText})`
      : 'rgb(255, 255, 255)'
    styleProps['--accent'] = themeAccentText
      ? `rgb(${themeAccentText})`
      : 'rgb(255, 255, 255)'
  }

  return (
    <div className={pageStyles[`${theme}Theme`]} style={styleProps} id={id}>
      {renderItem()}
    </div>
  )
}
